// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cm-a";
export var fulfillmentFormRail = "_cm-9";
export var headerTitleRow = "_cm-c";
export var orderDetailsWrapper = "_cm-7";
export var orderLinkTrigger = "_cm-2";
export var paymentInformationGrid = "_cm-h";
export var paymentSummaryColumn = "_cm-i";
export var shipmentContainer = "_cm-b";
export var shipmentDetailsMainPane = "_cm-8";
export var shipmentNavigationCard = "_cm-5";
export var shipmentNavigationRail = "_cm-3";
export var shipmentNavigationRailHeader = "_cm-4";
export var shipmentSummaryFact = "_cm-e";
export var shipmentSummaryGrid = "_cm-d";
export var shipmentSummaryMetadataRow = "_cm-f";
export var shipmentSummaryTags = "_cm-g";
export var shipmentWorkspace = "_cm-0";
export var shipmentWorkspaceContent = "_cm-6";
export var shipmentWorkspaceHeader = "_cm-1";